// import firebase from '@/firebase/firestore';

const state = {
  user: {},
  status: false,
  language: 'eng',
};

const getters = {
  user(state) {
    return state.user;
  },
  isSignedIn(state) {
    return state.status;
  },
};

const actions = {
  fetchAccount({commit},user){
    commit('onAuthStateChanged', user);
    commit('onUserStatusChanged', Boolean(user), !!user);
  },
};

const mutations = {
  onAuthStateChanged(state, user) {
    state.user = user; // firebaseが返したユーザー情報
    console.log('state.user : ' + user);
  },
  onUserStatusChanged(state, status) {
    state.status = status; // ログインしてるかどうか true or false
    console.log('state.status : ' + status);
  },
  setCurrentUserId: (state, uid) => (state.currentUserId = uid),
};

export default {
  state,
  getters,
  actions,
  mutations,
};

// 参考：https://www.youtube.com/watch?v=5lVQgZzLMHc